import { makeStyles } from '@material-ui/core/styles';

const useSettingsStyles = makeStyles(() => {
    const style = {};	

    style['mt_46'] = {
        marginTop: '46px',
    };

    style['p_16_text_center'] = {
        padding: '16px',
        textAlign: 'center',
    };
    
    style['transform_translateX_-24px'] = {
        transform: 'translateX(-24px)',
    };

    style['mt_16'] = {
        marginTop: '16px',
    };
    style['mb_16'] = {
        marginBottom: '16px',
    };

    style['text_align_right'] = {
        textAlign: 'right',
    };

    style['bg_black'] = {
        backgroundColor: 'black',
    };

    style['color_white'] = {
        color: 'white',
    };

    style['l_15'] = {
        left: '15px',
    };
    
    style['data-storage-dropdown-container'] = {
        top: '30px',
        left: '20px',
    }

    style['l_5'] = {
        left: '5px',
    }

    style['update-btn'] = {
        marginLeft: '15px',
        border: '1px',
    }
    
    style['data-storage-grid-container'] = {
        padding: '15px',
        marginTop: '15px',
    }

    style['p_15'] = {
        padding: '15px',
    }

    style['data-storage-para-container'] = {
        padding: '15px', 
        marginTop: '15px',
    }

    style['p_10'] = {
        padding: '10px',
    }

    style['classifier-input-field'] = {
        marginTop: '20px',
        marginBottom: '10px',
    }

    style['mb_10'] = {
        marginBottom: '10px !important',
    }
    style['popup-btn'] = {
        marginRight: '18px !important',
    }
    style['mr_10']  = {
        marginRight: '10px',
    }
    style['pl_10'] = {
        paddingLeft: '10px',
    }
    style['weight-bold'] = {
        margin: '0',
        fontWeight: 'bolder',
        color:'#4b4b4b'
    }
    style['border_top_gray'] = {
        borderTop : '1px #D0CCC9 solid'
    }

    style['weight-600'] = {
        fontWeight: '600',
    }
    style['flex-row'] = {
        display: 'flex',
    }
    style['test-match-label'] = {
        marginTop:'4px',
        marginLeft:'15px',
        fontSize:'12px'
    }
    return style;
})

export default useSettingsStyles;